<template lang="pug">
  #profile
    .container
      .box
        img(class="title-img", :src="getImgUrl('profile/profile-title')")
        form(@submit.prevent="updateProfile")
          .section-banner {{ $LANG.profile.MY_DETAILS }}
          ul
            li
              label {{ $LANG.profile.FIRST_NAME }}
                span(class="errorField", v-show="!form.firstName") &nbsp;*
              input(class="control-input", type="text", v-model="form.firstName", :disabled="disableEdit", @keydown="isNotNumber" @keyup="formatName" maxlength="35")
            li
              label {{ $LANG.profile.LAST_NAME }}
                span(class="errorField", v-show="!form.lastName") &nbsp;*
              input(class="control-input", type="text", v-model="form.lastName", :disabled="disableEdit", @keydown="isNotNumber" @keyup="formatName" maxlength="35")
            li
              label {{ $LANG.profile.NAME_IN_SMALAND }}
                span(class="errorField", v-show="!form.nameInSmaland") &nbsp;*
              input(class="control-input", type="text", v-model="form.nameInSmaland", maxlength="35", :disabled="disableEdit", @keydown="isNotNumber" @keyup="formatName")
            li
              label {{ $LANG.profile.DATE_OF_BIRTH }}
              .select-wrapper
                select(name="dob_day", v-model="form.dateOfBirth.day", disabled)
                  option {{ form.dateOfBirth.day }}
                select(name="dob_month", v-model="form.dateOfBirth.month", disabled)
                  option {{ form.dateOfBirth.month }}
                select(name="dob_year", v-model="form.dateOfBirth.year", disabled)
                  option {{ form.dateOfBirth.year }}
            li
              label {{ $LANG.profile.CITIZENSHIP_EXPIRY_DATE }}
              span.control-input {{ form.citizenExpiryDate }}
            li
              label {{ $LANG.profile.GENDER }}
              select(class="control-input", name="gender", v-model="form.gender", :disabled="disableEdit")
                option(value=0) {{ $LANG.profile.MALE }}
                option(value=1) {{ $LANG.profile.FEMALE }}
                option(value=2) {{ $LANG.profile.UNDISCLOSED }}
            //- li
            //-   label {{ $LANG.profile.RACE }}
            //-   select(class="control-input", name="race", v-model="form.race", :disabled="disableEdit")
            //-     option(value=2) {{ $LANG.profile.MALAY }}
            //-     option(value=0) {{ $LANG.profile.CHINESE }}
            //-     option(value=1) {{ $LANG.profile.INDIAN }}
            //-     option(value=3) {{ $LANG.profile.OTHERS }}
            //-     option(value=4) {{ $LANG.profile.UNDISCLOSED }}
          .section-banner {{ $LANG.profile.MY_GUARDIAN }}
          ul
            li
              label {{ $LANG.profile.GUARDIAN_NAME }}
              input(class="control-input", type="text", v-model="form.guardianName", disabled)
            li
              label {{ $LANG.profile.MOBILE_NUMBER }}
              input(class="control-input", type="text", v-model="form.guardianMobile", disabled)
            li
              label {{ $LANG.profile.ALTERNATIVE_CONTACT_NUMBER }}
              input(class="control-input", type="text", v-model="form.guardianAltContactNumber", disabled)
            li
              label {{ $LANG.profile.EMAIL }}
              input(class="control-input", type="text", v-model="form.emailAddress", disabled)
            li
              label {{ $LANG.profile.COUNTRY }}
              select(class="control-input", name="country", v-model="form.country", @change="changeCountry", disabled)
                option(value="Thailand") {{ $LANG.profile.COUNTRY_TH }}
                option(value="Singapore") {{ $LANG.profile.COUNTRY_SG }}
                option(value="Malaysia") {{ $LANG.profile.COUNTRY_MY }}
                option(value="Vietnam") {{ $LANG.profile.COUNTRY_VN }}
                option(value="Philippines") {{ $LANG.profile.COUNTRY_PH }}
                option(value="Laos") {{ $LANG.profile.COUNTRY_LAOS }}
            li
              label {{ $LANG.profile.POSTAL_CODE }}
                span(class="errorField", v-show="!form.postalCode") &nbsp;*
              input(class="control-input", type="text", v-model="form.postalCode", maxlength="6", @keydown="isNumber", disabled)
            li
              label {{ $LANG.profile.ADDRESS_LINE_ONE }}
                span(class="errorField", v-show="!form.addressLine1") &nbsp;*
              input(class="control-input", type="text", v-model="form.addressLine1", disabled)
            li
              label {{ $LANG.profile.ADDRESS_LINE_TWO }}
                //- span(class="errorField", v-show="!form.addressLine2") &nbsp;*
              //- div.singaporeaddress2(v-show="form.country === 'Singapore'")
              //-   input.singaporeaddress2-a(v-model="singaporeaddress2.a", maxlength="2", @keydown="isNumber", disabled)
              //-   span.singaporeaddress2-dash -
              //-   input.singaporeaddress2-b(v-model="singaporeaddress2.b", maxlength="6", @keydown="isNumber", disabled)
              //- input(class="control-input", type="text", v-model="form.addressLine2", v-show="form.country !== 'Malaysia'", disabled)
              input(class="control-input", type="text", v-model="form.addressLine2", disabled)
        .errorBox(v-show="showError && (!form.firstName || !form.lastName || !form.nameInSmaland || form.gender === '')")
          span(class="errorMessage", v-show="!form.firstName") {{ $LANG.profile.REQUIRED_FIRST_NAME }}
          span(class="errorMessage", v-show="!form.lastName") {{ $LANG.profile.REQUIRED_LAST_NAME }}
          span(class="errorMessage", v-show="!form.nameInSmaland") {{ $LANG.profile.REQUIRED_NAME_ON_CARD }}
          span(class="errorMessage", v-show="form.gender === ''") {{ $LANG.profile.REQUIRED_GENDER }}
          //- span(class="errorMessage", v-show="!form.race") {{ $LANG.profile.REQUIRED_RACE }}
        br
        .button-container
          router-link.desktop(:to="`/${$LOCALE}/dashboard`" gtm-label="profile.dashboard")
            img.buttons(:src="getImgUrl('btn-home')" gtm-label="profile.dashboard")
          .edit
            .item
              router-link.mobile(:to="`/${$LOCALE}/dashboard`" gtm-label="profile.dashboard")
                img.buttons(:src="getImgUrl('btn-home')" gtm-label="profile.dashboard")
            .item
              img.buttons(class="pointer", :src="getImgUrl('btn-edit')", @click="editProfile", v-if="disableEdit" gtm-label="profile.edit")
              img.buttons(class="pointer", :src="getImgUrl('btn-save')", @click="updateProfile", v-if="!disableEdit" gtm-label="profile.save")
          a(@click="logout" :class="{ en: $LOCALE === 'en', bm: $LOCALE === 'th', bmorph: !disableEdit && $LOCALE === 'th' }")
            img.buttons.logout(:src="getImgUrl('btn-logout')" gtm-label="profile.logout")
</template>

<script>
  import api from '../library/api.js'
  import dayjs from 'dayjs'

  export default {
    data () {
      return {
        showError: false,
        noEmail: false,
        allInterests: false,
        disableEdit: true,
        edited: false,
        form: {
          firstName: '',
          lastName: '',
          nameInSmaland: '',
          dateOfBirth: {
            day: '- Day -',
            month: '- Month -',
            year: '- Year -'
          },
          citizenExpiryDate: '-',
          gender: '',
          race: '',
          country: '',
          postalCode: '',
          houseNo: '',
          building: '',
          floor: '',
          moo: '',
          soi: '',
          street: '',
          state: '',
          district: '',
          subDistrict: '',
          altMobile: '',
          email: '',
          addressLine1: '',
          addressLine2: '',
          emailAddress: '',
          guardianName: '',
          guardianId: '',
          guardianMobile: '',
          guardianAltContactNumber: '',
          guardianEmailAddress: '',
          arts: false,
          envi: false,
          musi: false,
          pcac: false,
          cook: false,
          outd: false,
          gard: false,
          canMail: false,
          canEmail: false,
          canSms: false
        },
        optionList: {},
        singaporeaddress2: {
          a: '',
          b: ''
        }
      }
    },

    created () {
      if (!window.localStorage.getItem('token')) {
        this.$router.push('/')
      }
    },

    watch: {
      'form.firstName' (val) {
        this.form.firstName = val.toUpperCase()
        if (this.edited) {
          const nameOnCard = val + ' ' + this.form.lastName
          this.form.nameInSmaland = nameOnCard.substring(0, 35)
        }
      },

      'form.lastName' (val) {
        this.form.lastName = val.toUpperCase()
        if (this.edited) {
          const nameOnCard = this.form.firstName + ' ' + val
          this.form.nameInSmaland = nameOnCard.substring(0, 35)
        }
      }
    },

    mounted: function () {
      if (this.$LOCALE === 'th') {
        this.form.dateOfBirth.day = '- วัน -'
        this.form.dateOfBirth.month = '- เดือน -'
        this.form.dateOfBirth.year = '- ปี -'
      }

      this.getDropdownValues()
      this.getProfile()
    },

    methods: {
      isNumber (e) {
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.which) !== -1 ||
          (e.which === 65 && e.ctrlKey === true) ||
          (e.which === 67 && e.ctrlKey === true) ||
          (e.which === 88 && e.ctrlKey === true) ||
          (e.which >= 35 && e.which <= 39)) {
          return
        }
        if ((e.shiftKey || (e.which < 48 || e.which > 57)) && (e.which < 96 || e.which > 105)) {
          e.preventDefault()
        }
      },

      getImgUrl (pic) {
        return require('../assets/images/' + pic + '-' + this.$LOCALE + '.png')
      },

      isNotNumber (e) {
        const re = /[0-9]/
        e = e || window.event
        const charCode = (typeof e.which === 'undefined') ? e.keyCode : e.which
        const charStr = String.fromCharCode(charCode)
        if (re.test(charStr) && e.shiftKey === false) {
          e.preventDefault()
        }
      },

      formatName () {
        this.form.firstName = this.form.firstName.replace(/\s{2,}/g, ' ')
        this.form.firstName = this.form.firstName.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]+/g, '')
        this.form.lastName = this.form.lastName.replace(/\s{2,}/g, ' ')
        this.form.lastName = this.form.lastName.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]+/g, '')
        this.form.nameInSmaland = this.form.nameInSmaland.replace(/\s{2,}/g, ' ')
        this.form.nameInSmaland = this.form.nameInSmaland.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]+/g, '')
      },

      changeCountry () {
        this.form.postalCode = ''
        this.form.addressLine1 = ''
        this.form.addressLine2 = ''
        this.singaporeaddress2.a = ''
        this.singaporeaddress2.b = ''
      },

      getDropdownValues () {
        api('Values')
          .then(res => {
            res = JSON.parse(res)
            this.optionList = res
          })
      },

      validateEmail (email) {
        var regex = /^[^@]+@[^@]+\.[^@]+$/g

        return regex.exec(email) !== null
      },

      dateConverter (str, dateStyle) {
        let dob = {}

        dob.day = str.substring(0, 2)
        dob.month = str.substring(2, 4)
        dob.year = str.substring(4, 8)

        if (dateStyle) {
          dob = dob.day + dateStyle + dob.month + dateStyle + dob.year
          return dob
        }
        switch (dob.month) {
          case '01':
            dob.month = this.$LOCALE === 'en' ? 'January' : 'มกราคม'
            break
          case '02':
            dob.month = this.$LOCALE === 'en' ? 'February' : 'กุมภาพันธ์'
            break
          case '03':
            dob.month = this.$LOCALE === 'en' ? 'March' : "มีนาคม"
            break
          case '04':
            dob.month = this.$LOCALE === 'en' ? 'April' : "เมษายน"
            break
          case '05':
            dob.month = this.$LOCALE === 'en' ? 'May' : 'พฤษภาคม'
            break
          case '06':
            dob.month = this.$LOCALE === 'en' ? 'June' : 'มิถุนายน'
            break
          case '07':
            dob.month = this.$LOCALE === 'en' ? 'July' : 'กรกฎาคม'
            break
          case '08':
            dob.month = this.$LOCALE === 'en' ? 'August' : 'สิงหาคม'
            break
          case '09':
            dob.month = this.$LOCALE === 'en' ? 'September' : 'กันยายน'
            break
          case '10':
            dob.month = this.$LOCALE === 'en' ? 'October' : 'ตุลาคม'
            break
          case '11':
            dob.month = this.$LOCALE === 'en' ? 'November' : 'พฤศจิกายน'
            break
          case '12':
            dob.month = this.$LOCALE === 'en' ? 'December' : 'ธันวาคม'
            break
          default:
            // eslint-disable-next-line
            dob.month = dob.month
        }

        return dob
      },

      getProfile () {
        api('GetProfile')
          .then(res => {
            res = JSON.parse(res)
            res.dateOfBirth = this.dateConverter(dayjs(res.dateOfBirth).format('DDMMYYYY'))
            res.citizenExpiryDate = this.dateConverter(dayjs(res.citizenExpiryDate).format('DDMMYYYY'), '/')
            this.form = res

            if (this.form.gender === 'Male') {
              this.form.gender = 0
            } else if (this.form.gender === 'Female') {
              this.form.gender = 1
            } else {
              this.form.gender = 2
            }

            // if (res.country === 'Singapore' && res.addressLine2) {
            //   this.singaporeaddress2.a = res.addressLine2.split('-')[0]
            //   this.singaporeaddress2.b = res.addressLine2.split('-')[1]
            // }
          })
          .catch(err => {
            console.error(err)
            if (err.status === 401 || err.status === 403) {
              window.localStorage.removeItem('token')
              this.$router.push('/')
            }
          })
          .then(() => {
            this.edited = true
          })
      },

      editProfile () {
        this.disableEdit = false
      },

      validateForm () {
        if (!this.form.firstName ||
        !this.form.lastName ||
        !this.form.nameInSmaland ||
        this.form.gender === '') {
          return false
        }
        return true
      },

      updateProfile () {
        this.showError = false
        if (!this.validateForm()) {
          this.showError = true
          return
        }

        // if (this.form.country === 'Singapore') {
        //   if (this.singaporeaddress2.a && this.singaporeaddress2.b) {
        //     this.form.addressLine2 = this.singaporeaddress2.a + '-' + this.singaporeaddress2.b
        //   } else {
        //     this.form.addressLine2 = null
        //   }
        // }

        const updatableValues = {
          updatedValues: {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            nameInSmaland: this.form.nameInSmaland,
            gender: this.optionList.gender[this.form.gender]
          }
        }

        api('UpdateProfile', updatableValues)
          .then(() => {
            this.$router.push( '/' +  this.$LOCALE + '/profile-updated')
          })
          .catch(err => {
            console.error(err)
            if (err.status === 401 || err.status === 403) {
              window.localStorage.removeItem('token')
              this.$router.push('/' + this.$LOCALE)
            }
          })
      },

      logout () {
        api(`logout?token=${window.localStorage.getItem('token')}`)
        window.localStorage.removeItem('token')
        this.$router.push('/')
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../sass/variables"

  #profile
    .label-wrapper
      display: flex
      flex-wrap: wrap
      &.tnc
        .checkBox
          width: 30%
      +mobile
        flex-direction: column
      .checkBox
        display: flex
        flex-direction: row
        width: 50%
        margin: 0 0 10px 0
        +mobile
          width: 100%
        input[type="checkbox"]
          transform: scale(1.5)
          border: 1px solid #eee
        p
          margin: 2px 0 0 5px
          color: #666666
          font-size: 0.9em
    p
      &.grey
        color: #666666
        font-size: 0.9em
    .errorField
      color: red

    .white
      color: $white

    .black
      color: $black

    .grey
      color: $grey

    .section-banner
      // font-family: "kids-comic"
      background-color: $red
      color: $white
      padding: 5px
      width: 100%
      margin-top: 15px

    .box
      position: relative
      margin: 0 auto
      padding: 20px
      width: 550px
      height: 100%
      border-radius: 15px
      box-shadow: 0 0 25px #9ecaed
      background-color: #ffffff
      @media #{$mobile}
        box-shadow: 0 0
        width: 100%
        padding: 0

    .title-img
      position: absolute
      top: -4%
      right: 3%
      max-width: 300px
      @media #{$mobile}
        position: relative
        left: 0
        max-width: 100%

    form
      ul
        +clearlist
        font-size: 0.9em
        color: $grey

        li
          margin-top: 5px
          margin-bottom: 5px
          +mobile
            margin: 10px 0

          label
            float: left
            width: 50%
            @media #{$mobile-s}
              float: none
              width: 100%

          .control-input
            width: 50%
            @media #{$mobile-s}
              display: block
              width: 100%

          input, select
            +mobile
              padding: 5px
              font-size: 16px
              line-height: 20px

          .singaporeaddress2
            width: 100%

          .singaporeaddress2-a
            display: inline-block
            width: 60px

          .singaporeaddress2-dash
            display: inline-block
            padding: 0 4px

          .singaporeaddress2-b
            display: inline-block
            width: 180px
            @media #{$mobile}
              width: 40%
            @media #{$mobile-s}
              width: 68%

          .select-wrapper
            @media #{$mobile}
              display: block
              width: 100%
              select
                margin-right: 10px

          .checkbox-horizontal
            margin-right: 5px

            &.checkbox-horizontal + .checkbox-horizontal
              margin-left: 10px

      .other-info-container
        padding-top: 0

      .left
        float: left
        width: 50%

      .right
        float: left
        width: 50%

      .other-info
        margin-right: 10px
        margin-bottom: 10px

    .button-container
      display: flex
      justify-content: center
      width: 100%
      margin-top: 15px
      text-align: center
      +mobile
        flex-direction: column
      img
        +desktop
          height: 40px

    .pointer
      cursor: pointer

    .edit
      display: flex
      +mobile
        justify-content: center

    .item
      img
        +mobile
          width: 100%

    a
      &.en
        .logout
          +mobile
            max-width: 38%
      &.bm
        .logout
          +mobile
            max-width: 45%
      &.bmorph
        .logout
          +mobile
            max-width: 38%

    .errorBox
      margin: 0 auto
      border: 3px solid red
      width: 90%
      padding: 10px
      border-radius: 10px

      .errorMessage
        display: block
        color: red
        font-size: 11px
        font-weight: bold
        text-align: center
        margin-bottom: 2px
</style>
